// extracted by mini-css-extract-plugin
module.exports = {"tab_titles":"style_tab_titles__eGb8z","tab_title":"style_tab_title__lXkUo","tab_title_active":"style_tab_title_active__YsHca","hidden_tab":"style_hidden_tab__Kq63w"};